import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../common/state';
import { subscribe, SubscriptionSource, SubscriptionType } from '../../../filters/state/subscribings/serp_subscribe';
import { BottomSubscribe, IStateProps, TDispatchProps } from './index';

export const mapStateToProps = (state: IAppState) => {
  const { results, config } = state;

  const { aggregatedOffers, jsonQuery, queryString, subscriptionsStates } = results;

  const offersPerPage = Number(config.get('serp.offersPerPage'));

  /* istanbul ignore next */
  return {
    isAuthenticated: state.user.isAuthenticated,
    isShortView: aggregatedOffers >= offersPerPage,
    jsonQuery,
    queryString,
    subscriptionState: subscriptionsStates.bottom,
    userEmail: state.user.isAuthenticated ? state.user.email : undefined,
  };
};

/* istanbul ignore next */
export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSubmit: (email: string, subscribeNews: boolean = false) => {
    dispatch(subscribe(email, SubscriptionType.Bottom, subscribeNews, SubscriptionSource.Listing));
  },
});

export const BottomSubscribeContainer = connect<IStateProps, TDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(BottomSubscribe);
